console.log('test');

document.addEventListener('DOMContentLoaded', function() {
    if (window.location.href.includes('/products')) {
        console.log('test0');

        const buttons = document.querySelectorAll('a.btn.btn--primary:not([href="/pages/how-to-use"])');
        buttons.forEach(function(button) {
            button.addEventListener('click', function(event) {
              console.log('here');
                event.preventDefault(); // Prevent the default behavior of the anchor tag
                const target = document.querySelector('h1');
                
                    window.scrollTo({
                        top: target.offsetTop,
                        behavior: 'smooth'
                    });
                    console.log('test1');
                
            });
        });
    }
});
